export var ClientPlatformEnum;
(function (ClientPlatformEnum) {
    ClientPlatformEnum["IOS"] = "IOS";
    ClientPlatformEnum["ANDROID"] = "ANDROID";
    ClientPlatformEnum["WEB"] = "WEB";
})(ClientPlatformEnum || (ClientPlatformEnum = {}));
//# sourceMappingURL=client-platform.enum.js.map